import React from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

const ReusablesPage: React.FC = () => {
  const enableRutr = useFlag(LaunchDarklyFlag.ENABLE_RUTR);
  return enableRutr ? <div>Reusables</div> : null;
};

export default ReusablesPage;
